import React from 'react'
import { CardMedia } from '@material-ui/core'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import imageClientHandler from './imageClientHandler'


function StoryItemImage(props) {
  const { asset, api, width, height } = props
  const src = imageClientHandler(asset.link, api, width, height)
  const annotations = asset.annotations
    .map(a =>
      (<CardContent key={a._id}>
        <Typography variant="body1"  component="p">
          {a.text}
        </Typography>
      </CardContent>))

  return (
    <li
      style={{ listStyleType: 'none' }}
    >
      <CardMedia>
        <img className="c-media" src={ src } alt="" />
      </CardMedia>
      <CardContent>
        <Typography variant="caption" color="textSecondary" component="p">
          { asset.caption }
        </Typography>
      </CardContent>
      { annotations }
    </li>
  )
}

export default StoryItemImage
